import PropTypes from 'prop-types'

import {TYPES, useServiceIcon} from './dealer-service-config.js'
import DealerServiceContent from './dealer-service-content.js'

const CardDealerService = ({id, type = TYPES.BRIEF, service, description, isIncluded}) => {
  const getServiceIcon = useServiceIcon()
  const icon = getServiceIcon({id, isIncluded})
  const BASE_CLASS = `mt-CardDealerService--${type}`

  return (
    <div className={BASE_CLASS}>
      <DealerServiceContent
        className={BASE_CLASS}
        description={description}
        icon={icon}
        isIncluded={isIncluded}
        service={service}
        type={type}
      />
    </div>
  )
}

CardDealerService.displayName = 'CardDealerService'
CardDealerService.propTypes = {
  id: PropTypes.number.isRequired,
  isIncluded: PropTypes.bool,
  type: PropTypes.oneOf(Object.values(TYPES)).isRequired,
  service: PropTypes.string.isRequired,
  description: PropTypes.string
}

export default CardDealerService
